import Vue from "vue";
import gedManager from "./gedManager.vue";
// import filter from 'lodash/filter';
// import get from 'lodash/get';
import axios from "axios";

Vue.config.productionTip = false;

new Vue({
  render: h => h(gedManager),
  data() {
    return {
      endpoint: "",
      isLoading: false,
      documents: [],
      filters: {},
      contentText: {
        name: "Nom",
        size: "Taille",
        date: "Date",
        all: "Toutes",
        category: "Rubriques",
        year: "Années",
        nop: "Aucun document disponible"
      }
    };
  },
  methods: {
    fetchEndpoint() {
      this.isLoading = true;
      const theEndpoint = this.endpoint
        ? this.endpoint
        : "http://frey.lndo.site/wp-json/frey/v1/documents";
      axios
        .get(theEndpoint, { params: this.filters })
        .then(response => (this.documents = response.data))
        .finally(() => (this.isLoading = false));
    },
    setFilter(key, value) {
      // Do not set AGAIN the filter with the same value
      if (this.filters[key] === value) {
        return;
      }

      Vue.set(this.filters, key, value)

      if (key === 'date') {
        this.fetchEndpoint();
      }
    },
  },
  created() {
    this.endpoint = document
      .getElementById("app")
      .getAttribute("data-documents");

    const contentText =
      document.getElementById("app").getAttribute("data-contentText") || "";
    this.contentText =
      contentText.length > 0 ? JSON.parse(contentText) : this.contentText;
  },
  computed: {
    documentsCategories() {
      let documentsCats = [];
      if (this.documents) {
        for (const document of this.documents) {
          for (const category of document.category) {
            if (documentsCats.indexOf(category) < 0) {
              documentsCats.push(category);
            }
          }
        }
      }

      return documentsCats;
    },
    filteredDocuments() {
      const filteredCategories = this.filters.category || [];

      if (filteredCategories.length === 0  || filteredCategories === 'all') {
        return this.documents;
      }

      return this.documents.filter(document => {
        return (
          document.category.filter(
            value => filteredCategories.indexOf(value) !== -1
          ).length > 0
        );
      });
    }
  }
}).$mount("#app");
